module.exports = __webpack_public_path__ + "static/media/isometric.3e7855d3.png";